import { connect } from 'react-redux';
import { changeJourneyParam } from '@store/yourJourney/actions';

import { guestSelectors } from '@store/guest/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { paginationSelectors } from '@store/pagination/selectors';
import { Facilities } from './Facilities';
import { NormalizedStore } from '@store/entity/entity.types';

const mapStateToProps = (state: NormalizedStore) => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);
  return {
    property: entitySelectors.getProperty(state),
    facilitiesCategories: entitySelectors.getFacilitiesCategories(state),
    journeyParams,
    facilitiesPagination: paginationSelectors.getFacilitiesPagination(state),
    userHasAccessToFacilities: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
  };
};

const mapDispatchToProps = {
  changeJourneyParam,
};

export const FacilitiesConnected: any = connect(mapStateToProps, mapDispatchToProps)(Facilities);
